
import { ref, useContext } from '@nuxtjs/composition-api';
import useSubscription from '@/composable/useSubscription';


export default {
  props: {
    keepSubscription: {
      type: Boolean,
      default: false
    }
  },
  setup (_props, { emit }) {
    const { app } = useContext()
    const { getSubscriptionList, error } = useSubscription(app)

    const userName = ref('')
    const password = ref('')
    const formValid = ref(false);
    const loginResponse = ref(null)
    const errorMessages = ref([])
    const loginAction = async () => {
      errorMessages.value = []
      loginResponse.value = await getSubscriptionList({ userName: userName.value, password: password.value }, 'UN_PW');
      if (error.value.hasError) {
        errorMessages.value.push(error.value?.errorMessage)
      } else {
        emit('subscriptions-ready', {
          subscriptions: loginResponse,
          accessTokenType: 'UN_PW',
          userName: userName.value,
          password: password.value,
          accessToken: userName.value + password.value + 'UN_PW'
        })
      }
    }

    const handlePasswordInput = () => {
      errorMessages.value = []
    }


    return {
      handlePasswordInput,
      errorMessages,
      formValid,
      loginAction,
      userName,
      password
    }
  }
}
